import axios from "axios";
import React, {
    Component,
    useState,
    useEffect,
    useContext,
    lazy,
    Suspense,
} from "react";
import { Helmet } from "react-helmet";
import BitmediaAd from '../../../mission/bitmedia';
import AdSense from "react-adsense";
import { FaRegClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";
import Login_google from './.././../login';
import Buylink from './../../urlshorten_system/buy_link.jsx';
const LazyReCAPTCHA = lazy(() => import("../../../../app_structure/LazyReCAPTCHA"));
function Capdo5(props) {
    const capdo = props.data;
    const money = props.money;
    const [hustmediavipro, sethustmediavipro] = useState("");
    const [isLoading, setIsLoading] = useState("0");
    const [lienketjop, setlienketjop] = useState("");
    const [id_service, set_id_service] = useState("");
    const [category, setcategory] = useState("");
    const [nutorder, setnutorder] = useState("Please wait a moment 😊");
    const [disabledbutton, setdisabledbutton] = useState(false);
    const [id_tiktok, set_id_tiktok] = useState("");
    const [tiktok_users_id, set_tiktok_users_id] = useState("");
    const [showquangcao, setshowquangcao] = useState(false);
    const [nutxuly, setnutxuly] = useState("");
    const [show_input, set_show_input] = useState(false);
    const [code_input, setCode] = useState("");
    const [buttonTextjop, setButtontextjop] = useState(
        "Bình luận xong ấn đây để kiểm tra nhé");
    const [loading, setLoading] = useState(false);
    const [apikey, setapikey] = useState(false);
    const [chedo, setchedo] = useState("tiktokcmt");
    const [service, setservice] = useState("");
    const navigate = useNavigate();
    const handleClick = async (e) => {
        if (disabledbutton) {
            e.preventDefault();
            return;
        }
        // nếu cần check category
        if (category != 'partner') {
            startcheck();
        }
    };
    const xacnhanidtiktok = () => {

        const myCookieValue = Cookies.get('apikey');
        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!code_input) {
            setnutorder('xác nhận');
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            return
        }
        else {
            axios
                .post("https://hust.media/jop/tiktok/converttiktok.php", {
                    key: myCookieValue,
                    fullname: code_input,
                    mode: 'mode_tiktok_cmt'
                })
                .then((response) => testFunction(response))
                .catch((error) => alert_error(error));
        }
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        setnutxuly(0);
        if (info != '') {
            if (status == 1) {
                Cookies.set('tiktok_users_id', info.tiktok_users_id, { expires: 1 / 12 });
                set_tiktok_users_id(info.tiktok_users_id);

                setIsLoading("1");
                Cookies.set('id_tiktok', code_input, { expires: 1 / 12 });
                alert_success(message);
                setnutorder('✔️ Click to Confirm');
                set_id_tiktok(code_input);
            }
            else if (status == 0) {
                setnutorder('thủ lại');
                alert_error(message);
            }
            else {
                setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
                alert_error('Đã xảy ra lỗi vui lòng nhập lại');
            }
        }
        else {
            setnutorder('xác nhận');
            alert_error('Không tìm thấy dữ liệu');
        }
        // if (info.redirect != null && info.redirect != "") {
        //     setTimeout(function () {
        //         // Chuyển hướng sang trang web khác
        //         window.location.href = info.redirect;
        //     }, 1700);
        // }
    };
    const startcheck = async () => {
        // console.log(capdo);
        if (id_tiktok) {
            setIsLoading("1");
        }
        else {
            set_show_input(true);
        }
        setButtontextjop("Bình luận xong ấn đây để kiểm tra nhé");
    };
    useEffect(() => {
        setservice("tiktokcmt");
        laydulieujop("tiktokcmt");
        const myCookieValue = Cookies.get('apikey');
        const id_tiktok_cookie = Cookies.get('id_tiktok');
        const tiktok_users_id = Cookies.get('tiktok_users_id');
        if (myCookieValue) {
            setapikey(myCookieValue);
        }
        if (id_tiktok_cookie) {
            set_id_tiktok(id_tiktok_cookie);
        }
        if (tiktok_users_id) {
            set_tiktok_users_id(tiktok_users_id);
        }
    }, []);

    function laydulieujop(value) {
        const hustmediavipro = Cookies.get("hustmediavipro");
        sethustmediavipro(hustmediavipro);
        setLoading(false);
        set_show_input(false);
        const fetchLienketjop = async () => {
            try {
                const response = await axios.get(
                    "https://hust.media/link/load_mode/mode_tiktok_cmt_start.php?chedo=" + value + '&capdo='
                    + capdo + '&lienketcode=' + hustmediavipro
                );
                setlienketjop(response.data[0].lienketjop);
                setnutorder(response.data[0].textbutton);
                setcategory(response.data[0].category);
                set_id_service(response.data[0].id_service);
                setnutorder('xác nhận');
                setLoading(true);
            } catch (error) {
                alert_error("Lỗi xảy ra vui lòng load lại");
            }
        };

        fetchLienketjop();
    }
    function handleSubmit() {
        if (id_tiktok && tiktok_users_id) {
            checktim();
        }
        else {
            alert_error("Bạn chưa điền id tiktok");
        }
    };
    const checktim = async () => {
        setshowquangcao(1);
        setdisabledbutton(true);
        const hustmediavipro = Cookies.get("hustmediavipro");
        const myCookieValue = Cookies.get('apikey');
        const code_item = Cookies.get("code_item");
        setButtontextjop("Please wait a moment 😊");
        let data = JSON.stringify({
            url: lienketjop,
            username: "hustmedia1",
            chedo: chedo,
            lienket: hustmediavipro,
            id_tiktok: id_tiktok,
            apikey: myCookieValue,
            code_item: code_item,
            id_service: id_service,
            tiktok_users_id: tiktok_users_id
        });

        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: "https://hust.media/link/load_mode/mode_tiktok_cmt_end.php",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios
            .post(config.url, config.data, config.headers)
            .then((response) => {
                setnutxuly(0);
                setdisabledbutton(false);
                if (response.data.status == 1) {
                    const lienketjop = response.data.message;
                    console.log(lienketjop);
                    alert_success("Xác thực thành công");
                    setIsLoading("0");
                    setButtontextjop("Hust Media cảm ơn bạn đã ghé thăm");
                } else if (response.data.status == 9) {
                    set_show_input(false);
                    setLoading(false);
                    alert_success("Còn bước cuối là đến link");
                    setchedo("tiktokcmt");
                    setIsLoading("0");
                    setservice("tiktokcmt");
                    laydulieujop("tiktokcmt");
                    setButtontextjop("Hust Media cảm ơn bạn đã ghé thăm");
                }
                else if (response.data.status == 7) {
                    Cookies.set("capdovuotlink", 2, { expires: 1 / 12 }); // gọi hàm từ props để cập nhật liên kết trong component cha
                    alert_success("Còn 1 bước nữa là đến liên kết");
                    setButtontextjop("Xác thực thành công");
                    //   setIsLoading("0");
                    setTimeout(() => {
                        navigate("/home2/");
                    }, 1200);
                } else if (response.data.status == 2 || response.data.status == 0) {
                    setButtontextjop(response.data.message);
                    alert_error(response.data.message);
                } else {
                    setButtontextjop("Vượt link thất bại");
                    alert_error("Vượt link thất bại");
                }

                // setButtontextjop("Thành công");
                if (response.data.redirect != null && response.data.redirect != '') {
                    setTimeout(function () {
                        // Chuyển hướng sang trang web khác
                        window.location.href = response.data.redirect;
                    }, 1700);
                } else {
                    setButtontextjop('Bình luận xong ấn đây để kiểm tra nhé');
                }
            })
            .catch((error) => {
                setdisabledbutton(false);
                setnutxuly(0);
                alert_error(error);
                setButtontextjop('Bình luận xong ấn đây để kiểm tra nhé');
            });
    };

    return (
        <div>

            {showquangcao == 1 && (
                <Helmet>
                    {/* <script
                        async="async"
                        data-cfasync="false"
                        src="//ophoacit.com/1?z=5904788"
                    ></script> */}
                </Helmet>
            )}
            <div className="form-control">
                <div
                    style={{ textAlign: "center" }}
                    className="mt-0 justify-center items-center">
                    {apikey ? (<><Buylink money={money} hustmediavipro={hustmediavipro} /></>) : (<>
                        <div className="mb-1 ">
                            <div>Đăng nhập google để nhận link miễn phí</div>
                            <Login_google />
                        </div>
                        <div className="mb-1 ">Hoặc:</div>
                    </>)}
                    {loading == false ? (
                        <>
                            <div>
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                ></div>
                                <span>Đang tải dữ liệu</span>
                            </div>
                        </>
                    ) : (
                        loading == true && (
                            <>
                                {" "}
                                {lienketjop && (<a
                                    href={lienketjop}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={handleClick}
                                    aria-disabled={disabledbutton}
                                    className={`
                                    inline-block py-3 px-6 text-lg font-bold text-white
                                    bg-gradient-to-r from-blue-500 to-blue-700
                                    hover:from-blue-700 hover:to-blue-900
                                    rounded-lg shadow-md no-underline
                                    ${disabledbutton ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}
                                `}
                                >
                                    Bình luận tiktok để lấy liên kết
                                </a>)}

                                {!show_input ? (
                                    <>
                                        <button
                                            disabled={nutxuly == 1}
                                            type="button"
                                            className="py-3 px-6 text-lg font-bold text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 rounded-lg shadow-md"
                                            onClick={() => set_show_input(true)}
                                        >
                                            {'Đổi acc'}
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <div>
                                            <div className="relative flex">
                                                <h2 className="text-xl font-bold text-black mb-2  w-full">
                                                    Nhập id tiktok:
                                                </h2>
                                                <button
                                                    disabled={nutxuly == 1}
                                                    type="button"
                                                    className="bg-pink-400 text-white font-bold py-1 px-2 rounded-md ml-2"
                                                    onClick={() => laydulieujop(service)}
                                                >
                                                    <span className="text-xs font-medium text-white">
                                                        Reload jop
                                                    </span>
                                                </button>
                                                <button
                                                    disabled={nutxuly == 1}
                                                    type="button"
                                                    className="bg-pink-400 text-white font-bold py-1 px-2 rounded-md ml-2"
                                                    onClick={() => set_show_input(false)}
                                                >
                                                    <span className="text-base font-medium text-white">
                                                        quay lại
                                                    </span>
                                                </button>
                                            </div>

                                            <div className="relative flex">
                                                <input
                                                    type="text"
                                                    className="border-2 border-pink-400 rounded-md p-3 pl-10 w-full focus:outline-none focus:border-pink-500"
                                                    placeholder="Nhập id ở đây"
                                                    value={code_input}
                                                    onChange={(e) => setCode(e.target.value)}
                                                />
                                                <div className="absolute left-3 top-3">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                        className="h-6 w-6 text-pink-400"
                                                    >
                                                        {/* Icon sao chép */}
                                                    </svg>
                                                </div>
                                                <button
                                                    disabled={nutxuly == 1}
                                                    type="button"
                                                    className="bg-pink-400 text-white font-bold py-2 px-3 rounded-md ml-2"
                                                    onClick={() => xacnhanidtiktok()}
                                                >
                                                    {nutxuly == 1 && (
                                                        <div className="spinner-border" role="status"></div>
                                                    )}

                                                    <span className="text-lg font-medium text-white">
                                                        {nutorder}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {isLoading == 1 && (
                                    <button
                                        disabled={disabledbutton}
                                        onClick={handleSubmit}
                                        className={`
                                        mt-3 flex break-inside
                                        bg-purple-400 hover:bg-purple-300
                                        rounded-3xl px-8 py-2 mb-3 w-full
                                        dark:bg-slate-800 dark:text-white
                                        ${disabledbutton ? 'opacity-50 cursor-not-allowed' : ''}
                                        `}
                                    >
                                        <div className="flex items-center justify-between flex-1">
                                            {/* Hiển thị spinner khi đang chờ */}
                                            {buttonTextjop === "Please wait a moment 😊" && (
                                                <div
                                                    className="spinner-border animate-spin inline-block w-6 h-6 mr-2 text-white"
                                                    role="status"
                                                >
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            )}

                                            {/* Text của nút */}
                                            <span className="text-lg font-medium text-white">
                                                {buttonTextjop}
                                            </span>

                                            {/* Icon mũi tên bên phải */}
                                            <div className="text-xl">
                                                {'\u27A4'}
                                            </div>
                                        </div>
                                    </button>
                                )}
                            </>
                        )
                    )}
                </div>
            </div>
            <BitmediaAd />
            <div className="row fixrow">
                <div className="text-center">
                    <button className="mx-2 btn btn-primary"
                        onClick={() => window.open('https://hust.media/shop/content/blog_posts/freefltiktok/208', '_blank')}
                    >
                        Hướng dẫn
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Capdo5;
